<template>
  <div>
    <fieldset class="border p-2">
      <legend>
        <small style="font-size:15px; font-weight: bold">new transporter</small>
      </legend>
      <div>
        <form @submit.prevent="newTransporter()">
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label>Registration date</label>
                <input
                  type="date"
                  class="form-control reg_date"
                  placeholder="registration date"
                  required
                />
              </div>
              <div class="form-group">
                <label>Email address</label>
                <input
                  type="email"
                  class="form-control email_address"
                  placeholder="email address"
                  required
                />
              </div>
              <div class="form-group">
                <label>Contact person</label>
                <input
                  type="text"
                  class="form-control contact_person"
                  placeholder="contact person"
                  required
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Transporter name</label>
                <input
                  type="text"
                  class="form-control transporter_name"
                  placeholder="transporter name"
                  required
                />
              </div>
              <div class="form-group">
                <label>Mobile number</label>
                <input
                  type="number"
                  class="form-control mobile_number"
                  placeholder="mobile number"
                  required
                />
              </div>
              <div class="form-group">
                <label>Pin no</label>
                <input
                  type="text"
                  class="form-control pin_no"
                  placeholder="kra pin number"
                  
                />
              </div>
            </div>
          </div>
          <button type="submit" class="btn btn-primary btn-flat creatingTransporter">
            <i class="fa fa-truck"></i> create transporter
          </button>
          <button type="button" class="btn btn-info btn-flat creatingTransporterLoader">
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            <i class="fa fa-spinner fa-spin" style="font-size:24px"></i> please wait...
          </button>
        </form>
      </div>
    </fieldset>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import $ from 'jquery'
export default {
  created() {

  },
   methods: {
     ...mapActions(["newTransporter"])
   }
}
</script>
<style scoped>
.creatingTransporterLoader {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/transporters/transporter.vue